import { useCallback, useEffect, useRef, useState } from 'react'
import { DescendantRow } from '../../../../domain/value-object/ProjectPlanSnapshot'
import { useProjectPlanSnapshotRepository } from '../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'

export type UseDeliverableTaskSnapshotReturnValue = ReturnType<
  typeof useDeliverableTaskSnapshot
>

export const useDeliverableTaskSnapshot = (snapshotUuid: string) => {
  const { fetchDescendantsByRoot } = useProjectPlanSnapshotRepository()
  const cacheRef = useRef<Map<string, DescendantRow[]>>(new Map())
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    cacheRef.current = new Map()
  }, [snapshotUuid])

  const fetch = useCallback(
    async (rootUuid: string) => {
      const cached = cacheRef.current.get(rootUuid)
      if (cached) return cached
      setLoading(true)
      try {
        const result = await fetchDescendantsByRoot(snapshotUuid, rootUuid)
        cacheRef.current.set(rootUuid, result)
        return result
      } catch (error) {
        console.error('Failed to fetch descendants:', error)
        throw error
      } finally {
        setLoading(false)
      }
    },
    [snapshotUuid, fetchDescendantsByRoot]
  )

  return { fetch, loading }
}
